import { type BaseDto } from "@pasta/box-v2";
import { type UserDto } from "@pasta/front-auth-v2";

export enum FavoriteUserType {
  PRIVATE_MESSAGE = "privateMessage",
}

export interface FavoriteUserDto extends BaseDto {
  owner: UserDto;
  type: FavoriteUserType;
  email: string;
  position: number;
}
